import { ModalBody } from 'reactstrap'

export default ModalBody
